<template>
    <div class="details">
        <highlight-code lang="json">{{popupData}}</highlight-code>
    </div>
</template>

<script>
export default {
    props: {
        popupData: {
            type: Object,
            require: true
        },
        popupButton: {
            type: String
        },
        popupType: {
            type: String
        }
    },

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
